import React from "react";
import { Link } from "react-router";
import { DailyIcon } from "@/features/daily/components/DailyIcon";
import type { DayNavigatorVm } from "@/features/daily/components/diagnostic/diagnostic-view-model";

type Props = {
    nav: DayNavigatorVm;
    /** An account search spans 365 days: moving the day would answer nothing. */
    disabled: boolean;
    onPickDate: (date: string) => void;
};

const Step: React.FC<{ href: string | null; disabled: boolean; label: string; icon: string }> = ({ href, disabled, label, icon }) =>
    disabled || href === null ? (
        <button type="button" className="daily-icon-button" aria-label={label} disabled><DailyIcon name={icon} /></button>
    ) : (
        <Link className="daily-icon-button" to={href} aria-label={label}><DailyIcon name={icon} /></Link>
    );

/** B3 + D131: one Madrid calendar day at a time, never past the server's own today — compact, in the toolbar. */
export const DayNavigator: React.FC<Props> = ({ nav, disabled, onPickDate }) => (
    <nav className="daily-day-nav" aria-label="Día consultado">
        <Step href={nav.previousHref} disabled={disabled} label="Día anterior" icon="chevron_left" />
        <label className="daily-visually-hidden" htmlFor="daily-day-date">Día</label>
        <input
            id="daily-day-date"
            className="daily-date"
            type="date"
            value={nav.date}
            min={nav.min ?? undefined}
            max={nav.max}
            disabled={disabled}
            onChange={(event) => {
                const next = event.target.value;
                if (next !== "" && next <= nav.max && (nav.min === null || next >= nav.min)) onPickDate(next);
            }}
        />
        <Step href={nav.nextHref} disabled={disabled} label="Día siguiente" icon="chevron_right" />
        {disabled || nav.todayHref === null ? (
            <button type="button" className="daily-text-button" disabled>Hoy</button>
        ) : (
            <Link className="daily-text-button" to={nav.todayHref}>Hoy</Link>
        )}
    </nav>
);
